<template>
  <VLayout>
    <VFlex>
      <VCard>
        <VContainer fluid grid-list-md>
          <VLayout row wrap>
            <VFlex id="datePiker" style="display: contents;">
              <button @click="abrirCalendario" >
                <VIcon style="font-size: 30px;" color="primary" >calendar_month</VIcon>
              </button>
                <v-date-picker v-if="calendarioAberto" @input="fecharCalendario" v-model="dataSelecionada" color="primary" locale="pt" style="position: absolute; z-index: 9999;" />
            </VFlex>
            <VFlex>
              <FullCalendar
                content-height="auto"
                ref="calendario"
                scheduler-license-key="0034782852-fcs-1561659629"
                :droppable="true"
                :editable="true"
                :plugins="calendarPlugins"
                locale="pt-BR"
                :dates-above-resources="true"
                :slot-duration="parametros.duracaoLinha"
                :slot-label-interval="parametros.duracaoLinha"
                :slot-label-format="slotLabelFormat"
                :slot-event-overlap="true"
                :min-time="parametros.horaInicial"
                :max-time="parametros.horaFinal"
                :resources="recursos"
                :header="header"
                :custom-buttons="customButtons"
                :default-view="viewPadrao"
                :event-sources="[getEventos]"
                :dates-render="datesRender"
                :event-render="eventRender"
                :view-skeleton-render="rolarAteHorarioAtual"
                :resource-area-width="100"
                :resource-label-text="labelRecursos"
                :event-duration-editable="false"
                all-day-text="Bloqueios"
                :all-day-slot="mostrarSlotBloqueioColuna"
                @dateClick="dateClick"
                @eventClick="eventClick"
                @eventDrop="salvarAlteracaoComanda"
                :button-text="buttonText"
                :slot-width="50"
                :now-indicator="true"
                resource-order="sortOrder"
              />
            </VFlex>
          </VLayout>
          <VLayout
            v-if="comandaSalva"
            class="pa-1 calendarFooter"
            align-center
            row
          >
            <VFlex class="pa-0" xs>
              <VCard color="#58b558" class="item pa-0">
                <VCardText
                  :style="
                    resposta.tipo === 'sucesso'
                      ? 'background-color: #58b558; color: white'
                      : 'background-color: red; color: white'
                  "
                  class="item-text pa-1"
                >
                  {{ resposta.msg }}
                </VCardText>
              </VCard>
            </VFlex>
          </VLayout>
          <VLayout v-else class="pa-0 calendarFooter" align-center row>
            <span>
              <VTooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <VSwitch
                    v-model="switchTipoFiltro"
                    v-bind="attrs"
                    v-on="on"
                  ></VSwitch>
                </template>
                <span>{{ tipoFiltro }}</span>
              </VTooltip>
            </span>
            <VFlex
              class="pa-0"
              xs
              v-for="(cores, situacao) in coresAgenda"
              :key="situacao"
            >
              <VCard :color="cores.fundo" class="item pa-0">
                <VCardText
                  :style="{ color: cores.texto }"
                  class="item-text pa-0"
                >
                  {{ situacao }} <span>({{ totalStatus(situacao) }})</span>
                </VCardText>
              </VCard>
            </VFlex>
          </VLayout>
        </VContainer>
      </VCard>
    </VFlex>
    <BloqueioHorarios v-model="bloqueioHorarios" />
  </VLayout>
</template>


<script>
import FullCalendar from "@fullcalendar/vue";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import EsteticaApi from "@/common/api.service";
import moment from "moment";
import { mapState } from "vuex";
import eventos from "@/common/eventos";
import * as mutations from "@/plugins/mutations.nomes";
import BloqueioHorarios from "./Dialog/BloqueioHorarios";
import situacoes from "@/common/situacoes";
import TotaisComanda from "@/common/totais.comanda";
import datas from "../mixins/datas";
import jQuery from "jquery";
import ApiService from "@/common/api.service";
import alerts from "../common/alerts";

window.jQuery = jQuery;
window.$ = jQuery;

export default {
  name: "Agenda",
  components: {
    FullCalendar,
    BloqueioHorarios,
  },
  created() {
    eventos.barramento.$on(eventos.COMANDA_ALTERADA, this.atualizarEventos);
    eventos.barramento.$on(eventos.ATUALIZAR_TELA, this.atualizarEventos);
    eventos.barramento.$on(
      eventos.BLOQUEIOS_ATUALIZADOS,
      this.atualizarEventos
    );
    this.dataSelecionada = this.dataAtual;
  },
  activated() {
    eventos.barramento.$on(eventos.ATUALIZAR_TELA, this.atualizarEventos);
    this.carregaParametrosComanda(this.$route.params.idComanda, this.$route.params.dataAgendamento, this.$route.params.idProfissional);
    if(this.$store.state.paramsComanda.idComanda != null)
      this.redirecionaComanda(this.$store.state.paramsComanda);
  },
  updated() {
    this.aplicaCorFuncao();
  },
  data() {
    return {
      resposta: {},
      comandaSalva: false,
      switchTipoFiltro: true,
      bloqueioHorarios: false,
      listaDeHorariosDisponiveis: null,
      eventosCorrentes: [],
      profissionaisParaFiltro: [],
      profissionaisFuncaoCor: [],
      funcoesParaFiltro: [],
      agendamentosPorComanda: [],
      agendamentosPorServico: [],
      agendamentosPorBloqueio: [],
      situacoes: situacoes,
      dataSelecionada: [],
      datePiker: null,
      calendarioAberto: false,
      customButtons: {
        atualizar: {
          text: "Atualizar",
          click: () => eventos.barramento.$emit(eventos.ATUALIZAR_TELA),
        },
        bloqueios: {
          text: "Bloqueios",
          click: () => (this.bloqueioHorarios = true),
        },
        transpor: {
          text: "Alternar linhas/colunas",
          click: this.alternarVisualizacao,
        },
      },
      header: {
        left: "prev,next,today transpor",
        center: "title",
        right: "bloqueios atualizar",
      },
      buttonText: {
        today: "Hoje",
      },
      calendarPlugins: [
        resourceTimeGridPlugin,
        interactionPlugin,
        resourceTimelinePlugin,
      ],
      recursos: [
        {
          id: "0",
          title: "Carregando",
          idFuncaoProfissional: "0",
        },
      ],
      eventos: [],
      view: null,
      slotLabelFormat: {
        hour: "2-digit",
        minute: "2-digit",
        omitZeroMinute: false,
        meridiem: "short",
      },
    };
  },
  mixins: [datas],
  computed: {
    ...mapState([
      "tipoAgenda",
      "requisicoes",
      "dataAtual",
      "listaServicos",
      "filtroProfissionais",
      "filtroClientes",
      "filtroServicos",
      "filtroFuncoes",
      "parametros",
      "coresAgenda",
    ]),
    tipoFiltro() {
      return (
        "Filtro totais: " + (this.switchTipoFiltro ? "Serviço" : "Comanda")
      );
    },
    viewPadrao() {
      return (
        localStorage.getItem(process.env.VUE_APP_KEY_VIEW_CALENDARIO) ||
        "resourceTimeGrid"
      );
    },
    labelRecursos() {
      return this.tipoAgenda === "profissionais" ? "Profissionais" : "Espaços";
    },
    totalStatus: function () {
      let vm = this;
      return function (status) {
        if (status === "Bloqueio") {
          return this.agendamentosPorBloqueio.length;
        }
        if (this.switchTipoFiltro) {
          return vm.totalServicosPorTipo(status);
        }
        return vm.totalAgendamentosPorTipo(status);
      };
    },
    mostrarSlotBloqueioColuna() {
      return this.eventosCorrentes.some((e) => e.allDay);
    },
    situacoesNomes() {
      return situacoes.nomes;
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 1000);

      this.loader = null;
    },
    dataSelecionada(data) {
      if (data !== this.dataAtual) {
        this.$store.commit(mutations.ALTERAR_DATA_ATUAL, data);
      }
    },
    async mostrarSlotBloqueioColuna() {
      setTimeout(() => {
        this.gerarDiaSemana(this.$store.state.dataAtual);
      }, 10);
    },
    view(view) {
      this.$refs.calendario.getApi().changeView(view);
      localStorage.setItem(process.env.VUE_APP_KEY_VIEW_CALENDARIO, view);
      this.gerarDiaSemana(this.$store.state.dataAtual);
    },
    dataAtual(data) {
      if (
        data !==
        moment(this.$refs.calendario.getApi().getDate()).format(
          moment.HTML5_FMT.DATE
        )
      ) {
        this.$refs.calendario.getApi().gotoDate(this.dataAtual);
      }
    },
    tipoAgenda() {
      this.atualizarEventos();
    },
    filtroClientes() {
      this.atualizarEventos();
    },
    filtroProfissionais() {
      this.atualizarEventos();
    },
    filtroServicos() {
      this.atualizarEventos();
    },
    filtroFuncoes() {
      this.atualizarEventos();
    },
  },
  methods: {
    async abrirCalendario(){
      this.calendarioAberto = !this.calendarioAberto;
    },
    async fecharCalendario() {
      this.calendarioAberto = false;
    },
    async salvarComanda(idComanda, comanda, e) {
      try {
        const resposta = await ApiService.put(`comandas/${idComanda}`, comanda);

        if (resposta.status !== 204 && resposta.status !== 200)
          throw new Error();

        this.resposta = {
          msg: "Salvo com sucesso!",
          tipo: "sucesso",
        };
      } catch (error) {
        this.resposta = {
          msg: "Ocorreu um problema ao salvar!",
          tipo: "erro",
        };
        e.revert();
      } finally {
        this.comandaSalva = true;
        setTimeout(() => {
          this.comandaSalva = false;
        }, 5000);
      }
    },
    async buscarComanda(idComanda) {
      return await ApiService.getComanda(idComanda);
    },
    async verificarDisponibilidade(info, comanda, data) {
      if (comanda.situacao.toLowerCase() === "executado") return false;

      const profissionalId =
        this.tipoAgenda === "profissionais" &&
        info.newResource &&
        info.newResource.id
          ? parseInt(info.newResource.id)
          : comanda.profissionais.responsavel.id;

      if (this.$store.state.parametros.configuracoesServicos.restringeServicosPorProfissional)
      {
        const responseProfissionais = await ApiService.get("profissionais/porServico")
        const servicoId = comanda.servico ? comanda.servico.id : null;

        const servicoHabilitado = responseProfissionais.data.find((profissional) => {
          return (
            profissional.id === profissionalId &&
            profissional.idServico === servicoId
          );
        });

        if (!servicoHabilitado) return false;
      }

      const agendamento = data.split("T");
      const responseAgenda = await ApiService.getAgenda(this.tipoAgenda, agendamento[0])

      let existente = null;
      if (this.tipoAgenda === "profissionais")
        existente = responseAgenda.data.agendamentos.some(agendamento => agendamento.profissionais !== null && agendamento.profissionais.responsavel.id === profissionalId && agendamento.data === data);
      else if (this.tipoAgenda === "espacos") {
        const espacoId = info.newResource && info.newResource.id ? parseInt(info.newResource.id) : comanda.espaco.id;
        existente = responseAgenda.data.agendamentos.some(agendamento => agendamento.espaco.id === espacoId && agendamento.data === data);
      }

      return !existente ? true : false;
    },
    subtrairTempo(data, tempo) {
      let [horas, minutos] = tempo.split(':').map(Number);
      data.setHours(data.getHours() - horas);
      data.setMinutes(data.getMinutes() - minutos);
      return data;
    },

    async salvarAlteracaoComanda(info) {
      var ehRetroativo = false;

      if(info.event.extendedProps.idComanda == undefined){
        info.revert();
        return;
      }

      const data = moment(info.event.start).format("YYYY-MM-DDTHH:mm:ss");
      this.dataIso(moment(info.event.start));

      var dataAtual = new Date();
      var dataComparacao = new Date(data);
      console.log(dataAtual, dataComparacao);

      if(dataAtual > dataComparacao){
        ehRetroativo = true;
      }

      dataAtual = this.subtrairTempo(dataAtual, this.$store.state.parametros.configuracoes.toleranciaAgendamento ? this.$store.state.parametros.configuracoes.toleranciaAgendamento : 0);

      if (ehRetroativo && (dataAtual > dataComparacao)) {
        await alerts.exibirInformacao("Horário indisponível para agendamento", "Horário fora do limite parametrizado em Agenda > Configurações > Tolerância para Agendamentos");
        info.revert();
        return;
      }

      const comanda = await this.buscarComanda(
        info.event.extendedProps.idComanda
      );

      const eventoComanda = comanda.data.eventos.find(
        (e) => e.id == info.event.id
      );

      const disponivel = await this.verificarDisponibilidade(
        info,
        eventoComanda,
        data
      );

      if (!disponivel) {
        info.revert();
        return;
      }

      let dados = {};
      if (this.tipoAgenda === "profissionais") {
        dados = {
          idEvento: info.event.id,
          idComanda: comanda.data.id,
          idEspaco: eventoComanda.espaco.id,
          novoProfissional: {
            id:
              info.newResource && info.newResource.id
                ? parseInt(info.newResource.id)
                : eventoComanda.profissionais.responsavel.id,
            preferencial: eventoComanda.profissionais.responsavel.preferencial,
          },
          hora: data,
        };
      } else {
        dados = {
          idEvento: info.event.id,
          idComanda: comanda.data.id,
          idEspaco:
            info.newResource && info.newResource.id
              ? parseInt(info.newResource.id)
              : eventoComanda.espaco.id,
          novoProfissional: {
            id: eventoComanda.profissionais.responsavel.id,
            preferencial: eventoComanda.profissionais.responsavel.preferencial,
          },
          hora: data,
        };
      }

      const payload = this.getPayloadAlteracaoEvento(dados, comanda.data);
      await this.salvarComanda(dados.idComanda, payload, info);
    },
    getPayloadAlteracaoEvento(dadosNovos, comanda) {
      const produtosComanda = comanda.produtos.map((produto) => {
        return {
          id: produto.id,
          idProfissional: produto.profissional.id,
          quantidade: produto.quantidade,
        };
      });
      return {
        data: comanda.data,
        noiva: comanda.noiva,
        transacaoAssociadaReshop: comanda.transacaoAssociadaReshop,
        observacoes: comanda.observacoes,
        desconto: comanda.desconto,
        fechada: comanda.fechada,
        idNumeroManual: comanda.idNumeroManual,
        campanhasOpcionaisReshop: comanda.campanhasOpcionaisReshop,
        produtos: produtosComanda,
        insumos: comanda.insumos,
        gorjetas: comanda.gorjetas,
        valorTotal: comanda.valorTotal,
        valorTotalCortesia: comanda.valorTotalCortesia,
        valorFinal: comanda.valorFinal,
        eventos: comanda.eventos.map((e) => {
          let descontoEvento = e.desconto
            ? {
                tipo: e.desconto.tipo,
                valor: parseFloat(e.desconto.valor.toFixed(2)),
              }
            : undefined;
          return {
            id: e.id || null,
            hora: e.id == dadosNovos.idEvento ? dadosNovos.hora : e.hora,
            servicoAvulso: e.servicoAvulso,
            cortesiaAvulso: e.servicoAvulso && e.cortesiaAvulso,
            duracao: e.duracao,
            idServico: e.servicoAvulso ? e.servico.id : undefined,
            idClienteServico: !e.servicoAvulso
              ? e.servico.idClienteServico
              : undefined,
            idEspaco:
              e.id == dadosNovos.idEvento ? dadosNovos.idEspaco : e.espaco.id,
            desconto: descontoEvento,
            profissionais:
              e.id == dadosNovos.idEvento
                ? e.profissionais.responsavel && dadosNovos.novoProfissional.id
                  ? {
                      responsavel: {
                        id: dadosNovos.novoProfissional.id,
                        preferencial: e.profissionais.responsavel.preferencial,
                      },
                      auxiliares: [...e.profissionais.auxiliares],
                    }
                  : {
                      responsavel: null,
                      auxiliares: [],
                    }
                : e.profissionais,
            situacao: e.situacao,
            idFormularioPreenchido: e.idFormularioPreenchido || null,
            chave: e.chave || null,
          };
        }),
      };
    },
    rolarAteHorarioAtual() {
      this.aplicaCorFuncao();
      this.$refs.calendario
        .getApi()
        .scrollToTime(this.formatarHora(new Date()));
    },
    alternarVisualizacao() {
      this.view =
        (this.view || this.viewPadrao) === "resourceTimeGrid"
          ? "resourceTimeline"
          : "resourceTimeGrid";
    },
    getSituacao(a) {
      return situacoes.filter(
        (s) => a.situacao === s.situacao && s.condicao(a)
      )[0];
    },
    getMapaServicos(a, mapa) {
      if (
        this.filtroProfissionais != undefined &&
        this.filtroProfissionais.length > 0
      ) {
        for (const profissionalFiltro of this.filtroProfissionais) {
          var adicionarServico = false;
          for (const auxiliar of a.profissionais.auxiliares) {
            if (profissionalFiltro == auxiliar.nomeFantasia) {
              adicionarServico = true;
            }
          }

          if (!adicionarServico) {
            if (
              profissionalFiltro == a.profissionais.responsavel.nomeFantasia
            ) {
              adicionarServico = true;
            }
          }

          if (adicionarServico) {
            mapa.set(a.servico.id, a.servico.nome);
          }
        }
      } else {
        mapa.set(a.servico.id, a.servico.nome);
      }
      return mapa;
    },
    totalAgendamentosPorTipo(tipo) {
      TotaisComanda.init(this.agendamentosPorComanda);
      return TotaisComanda.getStatusFinalPorTipo(tipo);
    },
    totalServicosPorTipo(tipo) {
      var contador = 0;
      let eventosUnicos = this.agendamentosPorServico;
      eventosUnicos.filter((evento) => {
        if (evento && evento.situacao === tipo) {
          contador += 1;
        }
        return;
      });
      return contador;
    },
    agruparEventosPorComanda(eventosUnicos) {
      let eventosAgrupadosPorComanda = [];

      eventosUnicos.forEach((comanda) => {
        let existe = false;

        if (eventosAgrupadosPorComanda.length > 0) {
          eventosAgrupadosPorComanda.forEach((registro) => {
            if (
              registro.extendedProps.idComanda ==
              comanda.extendedProps.idComanda
            ) {
              existe = true;
            }
          });
        }

        if (!existe) {
          eventosAgrupadosPorComanda.push(comanda);
        }
      });
      return eventosAgrupadosPorComanda;
    },
    removeEventosDuplicados(eventos, propriedade) {
      return eventos.filter((obj, pos, arr) => {
        return (
          arr.map((mapObj) => mapObj[propriedade]).indexOf(obj[propriedade]) ===
            pos || obj.situacao === "Bloqueio"
        );
      });
    },
    atualizarEventos() {
      this.$refs.calendario.getApi().refetchEvents();
    },
    eventClick(info) {
      if (info.event.extendedProps.idComanda) {
        this.abrirDialogComanda(
          info.event.start,
          info.event.extendedProps.idComanda,
          info.event._def.resourceIds[0]
        );
      }
    },
    async dateClick(info) {
      const dataAtual = new Date();

      var toleranciaAgendamento = this.$store.state.parametros.configuracoes.toleranciaAgendamento ? this.$store.state.parametros.configuracoes.toleranciaAgendamento.split(':') : "00:00";
      var toleranciaAgendamentoSegundos = (+toleranciaAgendamento[0]) * 60 * 60 + (+toleranciaAgendamento[1]) * 60;
      const dataSelecionada = info.date.setTime(info.date.getTime() + toleranciaAgendamentoSegundos * 1000);

      if(dataSelecionada < dataAtual)
        return await alerts.exibirInformacao("Horário indisponível para agendamento", "Horário fora do limite parametrizado em Agenda > Configurações > Tolerância para Agendamentos");
      var horarioServico = info.dateStr.split("T")[1].split("-")[0];
      var format = "hh:mm";
      var time = moment(horarioServico, format);
      var horariosDisponiveis = [];
      var intervaloRespeitado = false;
      time.add(1, "seconds");

      this.listaDeHorariosDisponiveis.forEach((element) => {
        if (element.id == info.resource.id) {
          element.horariosDisponiveis.forEach((horario) => {
            horariosDisponiveis.push([horario.inicio, horario.fim]);
          });
        }
      });
      horariosDisponiveis.forEach((conjuntoHorario) => {
        if (
          time.isBetween(
            moment(conjuntoHorario[0], format),
            moment(conjuntoHorario[1], format)
          )
        ) {
          intervaloRespeitado = true;
        }
      });

      if (!info.allDay && intervaloRespeitado)
        this.abrirDialogComanda(info.dateStr, null, info.resource.id);
      else await alerts.exibirErro("Horário indisponível para agendamento.");
    },
    abrirDialogComanda(data, idComanda = null, idRecurso = null) {
      let idProfissional = null,
        idEspaco = null;
      if (this.tipoAgenda === "profissionais")
        idProfissional = Number.parseInt(idRecurso);
      else idEspaco = Number.parseInt(idRecurso);

      eventos.barramento.$emit(eventos.ABRIR_DIALOG_COMANDA, {
        idComanda,
        sugestoes: {
          idEspaco,
          idProfissional,
          horario: moment(data).format("HH:mm"),
        },
        data: moment(data).format("YYYY-MM-DD"),
      });
    },
    ordenarLista(response) {
      var lista = response.data.colunas;
      var existeConfiguracaoPorFuncao = false;

      if (this.$store.state.parametros.configuracoes != null) {
        if (
          this.$store.state.parametros.configuracoes.funcaoCoresItems != null
        ) {
          if (
            this.$store.state.parametros.configuracoes.funcaoCoresItems.length >
            0
          ) {
            existeConfiguracaoPorFuncao = true;
          }
        }
      }

      if (existeConfiguracaoPorFuncao) {
        var listaPorFuncao = [];
        this.funcoesParaFiltro.forEach((funcao) => {
          lista.forEach((registro) => {
            if (registro.idFuncaoProfissional == funcao.id) {
              for (var funcCor of this.$store.state.parametros.configuracoes
                .funcaoCoresItems) {
                if (funcCor.funcao.id == funcao.id) {
                  registro.cor = funcCor.cor;
                }
              }
              listaPorFuncao.push(registro);
            }
          });
        });
        lista = listaPorFuncao;
      }
      this.listaDeHorariosDisponiveis = lista;
      return lista.map((c, index) => {
        this.profissionaisParaFiltro.push(c.titulo);
        return {
          id: c.id,
          title: c.titulo,
          idFuncaoProfissional: c.idFuncaoProfissional,
          sortOrder: index,
          businessHours:
            c.horariosDisponiveis.length > 0 && !c.motivoBloqueio
              ? c.horariosDisponiveis.map((hd) => ({
                  daysOfWeek: [moment(c.data).toDate().getDay()],
                  startTime: hd.inicio,
                  endTime: hd.fim,
                }))
              : { startTime: "00:00", endTime: "00:00" },
          cor: c.cor,
          orderTitle: c.id === 0 ? "" : c.titulo,
        };
      });
    },
    getEventos(info, successCallback, failureCallback) {
    EsteticaApi.getAgenda(this.tipoAgenda, info.start)
        .then((response) => {
          this.profissionaisParaFiltro = [];
          this.funcoesParaFiltro = [];
          response.data.funcoes.map((f) => {
            this.funcoesParaFiltro.push(f);
          });

          this.recursos = this.ordenarLista(response);
          if (this.filtroProfissionais.length > 0) {
            this.recursos = this.recursos.filter((e) => {
              return this.filtroProfissionais.includes(e.title);
            });
          }

          if (this.filtroFuncoes.length > 0) {
            this.recursos = this.recursos.filter((f) => {
              return this.filtroFuncoes.includes(f.idFuncaoProfissional);
            });
          }

          this.eventosCorrentes = [];
          this.agendamentosPorComanda = [];
          this.agendamentosPorServico = [];
          this.idsComandas = [];

          response.data.agendamentos.forEach((a) => {
            let situacao = this.getSituacao(a);
            this.agendamentosPorServico.push({
              idComanda: a.idComanda,
              situacao: situacao.nome,
              servico: a.servico,
            });
          });
          var mapaServicos = new Map();
          for (var c of response.data.colunas) {
            this.eventosCorrentes = this.eventosCorrentes.concat(
              c.agendamentos
                .map((a) => {
                  let situacao = this.getSituacao(a);
                  mapaServicos = this.getMapaServicos(a, mapaServicos);

                  this.agendamentosPorComanda.push({
                    idComanda: a.idComanda,
                    situacao: situacao.nome,
                    servico: a.servico,
                  });
                  return {
                    allDay: false,
                    servico: a.servico,
                    id: a.id,
                    resourceId: c.id,
                    title: `${a.noiva ? '👰' : ''} ${a.resumo.split("-")[1]} (${a.servico.nome.slice(0, 5)}) `,
                    start: moment(a.data).toDate(),
                    end: moment(a.data).add(a.duracao, "minutes").toDate(),
                    backgroundColor: this.coresAgenda[situacao.nome].fundo,
                    textColor: this.coresAgenda[situacao.nome].texto,
                    borderColor: "black",
                    professionals: a.profissionais,
                    extendedProps: {
                      idComanda: a.idComanda,
                      situacao: situacao.nome,
                      loginUsuario: a.usuarioCriacao
                        ? a.usuarioCriacao.login
                        : null,
                      qtdServicos: a.qtdServicos,
                    },
                  };
                })
                .concat(
                  c.horariosBloqueados.map((hb) => ({
                    backgroundColor: this.coresAgenda.Bloqueio.fundo,
                    textColor: this.coresAgenda.Bloqueio.texto,
                    resourceId: c.id,
                    title: hb.motivo,
                    borderColor: "transparent",
                    start: moment(hb.inicio).toDate(),
                    end: moment(hb.fim).toDate(),
                    extendedProps: {
                      situacao: "Bloqueio",
                    },
                  }))
                )
            );
            if (c.motivoBloqueio) {
              this.eventosCorrentes.push({
                backgroundColor: this.coresAgenda.Bloqueio.fundo,
                textColor: this.coresAgenda.Bloqueio.texto,
                borderColor: "transparent",
                title: c.motivoBloqueio,
                resourceId: c.id,
                allDay: true,
                start: c.data,
                end: c.data,
                extendedProps: {
                  situacao: "Bloqueio",
                },
              });
            }
          }
          let mapear = [];
          mapaServicos = Array.from(mapaServicos);
          mapaServicos.map((ancorar) => {
            mapear.push(ancorar[1]);
            return ancorar;
          });

          this.$store.commit(mutations.ATUALIZAR_LISTA_SERVICOS, mapear);
        })
        .then(() => {
          this.$store.commit(
            mutations.ATUALIZAR_LISTA_PROFISSIONAIS,
            this.profissionaisParaFiltro
          );
          this.agendamentosPorBloqueio = this.eventosCorrentes.filter(
            (e) => e.extendedProps.situacao === "Bloqueio"
          );
        })
        .then(() => {
          this.$store.commit(
            mutations.ATUALIZAR_LISTA_FUNCOES,
            this.funcoesParaFiltro
          );
        })
        .then(() => {
          if (this.filtroClientes) {
            this.eventosCorrentes = this.eventosCorrentes.filter((com) => {
              return com.title
                .toLowerCase()
                .includes(this.filtroClientes.toLowerCase());
            });
            successCallback(this.eventosCorrentes);
          }
        })
        .then(() => {
          if (this.filtroServicos.length > 0) {
            this.eventosCorrentes = this.eventosCorrentes.filter((com) => {
              if (com.servico && com.servico.nome) {
                return this.filtroServicos.includes(com.servico.nome);
              }
              return;
            });
          }
          successCallback(this.eventosCorrentes);
        })
        .catch((err) => failureCallback(err));
    },
    datesRender(info) {
      this.$store.commit(
        mutations.ALTERAR_DATA_ATUAL,
        moment(info.view.currentStart).format(moment.HTML5_FMT.DATE)
      );
      this.gerarDiaSemana(info.view.currentStart);
    },
    gerarDiaSemana(info) {
      var diaSemana = [
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
        "Domingo",
      ];
      var dia = moment(info).isoWeekday() - 1;
      jQuery(".fc-center h2").children().remove();

      if(!this.datePiker)
        this.datePiker = document.getElementById( "datePiker" );

      jQuery(".fc-center h2").append(" (" + diaSemana[dia] + ") ", [this.datePiker]);
    },
    eventRender(info) {
      if (info.event.id) {
        var loginUsuario = info.event.extendedProps.loginUsuario;
        var qtdServicos = info.event.extendedProps.qtdServicos;
        info.el.setAttribute(
          "title",
          loginUsuario
            ? `Criado por ${loginUsuario} [${qtdServicos}]`
            : info.event.extendedProps.servico.nome
        );
      }
    },
    aplicaCorFuncao() {
      var listaElementos = jQuery("[data-resource-id]");

      for (var el of listaElementos) {
        var id = el.getAttribute("data-resource-id");
        for (var rec of this.recursos) {
          if (rec.cor != undefined && rec.id == id) {
            el.style.backgroundColor = rec.cor.fundo.concat("52");
            el.style.color = rec.cor.texto;
          }
        }
      }
    },
    carregaParametrosComanda(idComanda, dataAgendamento, idProfissional) {
      this.$store.state.paramsComanda.idComanda = idComanda;
      this.$store.state.paramsComanda.dataAgendamento = dataAgendamento;
      this.$store.state.paramsComanda.idProfissional = idProfissional;
    },
    redirecionaComanda(info) {
      this.abrirDialogComanda(
        new Date(info.dataAgendamento),
        info.idComanda,
        info.idProfissional
      );
      this.$store.state.paramsComanda.idComanda = null;
      this.$store.state.paramsComanda.dataAgendamento = null;
      this.$store.state.paramsComanda.idProfissional = null;
    },
  },
};
</script>

<style lang='scss'>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/timeline/main.css";
@import "~@fullcalendar/resource-timeline/main.css";

.comp-full-calendar {
  width: auto !important;
}

.fc-icon {
  display: contents !important;
}

.item {
  flex: 1;
  margin: 10px;
}

.item-text {
  text-align: center;
  font-size: 1rem;
}

.calendarFooter {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: #fff;
}
</style>
